module.exports = __webpack_public_path__ + "media/images/BellNotificationEmpty-422e59a6.svg";